import { Box, Button, Text } from "@dehub/theme";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  return (
    <Box
      h="100vh"
      w="100vw"
      bg="gray.0"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <Text fz={150} fw={600} c="gray">
        404
      </Text>
      <Text fz={16} fw={500} c="gray" ta="center">
        {t("notFound.message")}
      </Text>
      <Button
        variant="gradient"
        gradient={{ from: "var(--mantine-color-white)", to: "var(--mantine-color-brand-6)", deg: 15 }}
        mt="lg"
        onClick={() => navigate("/organization")}>
        {t("notFound.home")}
      </Button>
    </Box>
  );
}
